import styled from 'styled-components';

import colors from 'themes/Main';

const { gray01, gray02, blue } = colors;

export const Container = styled.div`
  width: 280px;
  padding: 16px;
`;

export const Certificate = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.div`
  min-width: 36px;
  margin-right: 8px;
`;

export const Descriptions = styled.div`
  font-size: 14px;
  overflow: hidden;

  > p {
    user-select: none;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CertificateArea = styled.p`
  color: ${gray02};
  font-style: italic;
`;

export const CertificateBlock = styled.p`
  color: ${gray02};
`;

export const CertificateQuestion = styled.p`
  font-weight: 700;
  color: ${gray01};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;

  button:first-child {
    margin-right: 16px;
  }
`;

export const ViewCertificate = styled.button`
  background-color: transparent;
  border: 0;
  outline: none;
  font-size: 12px;
  color: ${blue};
  text-decoration: underline;
  transition: all 0.3s ease-in-out;

  svg {
    margin-right: 4px;
  }

  &:hover {
    opacity: 0.6;
  }
`;

export const DownloadCertificate = styled.a`
  font-size: 12px;
  color: ${blue};
  text-decoration: underline;
  transition: all 0.3s ease-in-out;

  svg {
    margin-right: 4px;
  }

  &:hover {
    opacity: 0.6;
    color: ${blue};
    text-decoration: underline;
  }
`;
